/**
 * Application configuration - single source of truth for app-wide constants
 * 
 * For frontend: Import directly from this file
 * For edge functions: Use Deno.env.get("APP_URL") which should match PRODUCTION_URL
 */

// Production canonical URL - the single source of truth
export const PRODUCTION_URL = "https://www.coachveera.com";

const TOTAL_FOCUS_COACH_EMAIL = "andy@totalfocus.com.au";

/**
 * Get the base URL for the application.
 * Uses window.location.origin for auth redirects (works with any domain including previews)
 * Uses PRODUCTION_URL for invite links and external-facing URLs
 */
export const getAppBaseUrl = (): string => {
  // For invite links, emails, and external URLs, always use production
  return PRODUCTION_URL;
};

/**
 * Get the current origin for auth redirects
 * This allows auth to work correctly on preview and local environments
 */
export const getCurrentOrigin = (): string => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return PRODUCTION_URL;
};

/**
 * Get the base URL for invite links.
 * Uses an explicit override when provided, otherwise keeps users on the current origin.
 */
export const getInviteBaseUrl = (): string => {
  const override = import.meta.env.VITE_INVITE_BASE_URL;
  if (override) {
    return override;
  }
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return PRODUCTION_URL;
};

/**
 * Build an invite URL with the configured invite base
 */
export const buildInviteUrl = (token: string): string => {
  return `${getInviteBaseUrl()}/invite/${token}`;
};

/**
 * Total Focus coaching partner contact for the Solo Mode bridge.
 */
export const getTotalFocusCoachEmail = (): string => {
  return import.meta.env.VITE_TOTAL_FOCUS_COACH_EMAIL || TOTAL_FOCUS_COACH_EMAIL;
};
